import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import { Clipboard, Platform } from 'react-native';
import { lang } from '@/common/const';
import { $k18n as _k18n } from '@/common/i18n';
import { CountryNameList, currentCountry } from '@/common/const';

dayjs.extend(utc);

// const LOCALE = $k18n?.global?.locale || 'en';
const LOCALE = lang || 'en';

export const dateFormattor = (date: number | undefined) => {
    return date ? dayjs(date).format('YYYY/MM/DD HH:mm:ss') : '';
};

export const formatTime = (time: number, format = 'YYYY/MM/DD HH:mm:ss') => {
    if (!time) {
        return '';
    }
    if (CountryNameList.IDN.includes(currentCountry) || LOCALE === 'id') {
        // 印尼用东七区
        return `${dayjs(time).utcOffset(7).format('DD/MM/YYYY HH:mm:ss')} WIB`;
    }
    return dayjs(time).format('YYYY/MM/DD HH:mm:ss');
};

export const paymentMap = {
    // BOLETO: $k18n('Boleto'),
    // CREDIT_CARD: $k18n('Credit card'),
    // DEBIT_CARD: $k18n('Debit card'),
    // MERCADO_PAGO: $k18n('Mercado Pago'),
    // PAYPAL: $k18n('Paypal'),
    // PIX: $k18n('Pix'),
    // PICPAY: $k18n('Picpay'),
    BOLETO: 'Boleto',
    CREDIT_CARD: 'Credit Card',
    DEBIT_CARD: 'Debit Card',
    MERCADO_PAGO: 'Mercado Pago',
    PAYPAL: 'Paypal',
    PIX: 'Pix',
    PICPAY: 'Picpay',
    COD: 'Cash on Delivery',
};

export const getPaymentMap = () => ({
    BOLETO: _k18n('Boleto'),
    CREDIT_CARD: _k18n('Credit Card'),
    DEBIT_CARD: _k18n('Debit Card'),
    MERCADO_PAGO: _k18n('Mercado Pago'),
    PAYPAL: _k18n('Paypal'),
    PIX: _k18n('Pix'),
    PICPAY: _k18n('Picpay'),
    DANA: _k18n('DANA'),
    BANK_TRANSFER: 'BANK_TRANSFER',
    GO_PAY: _k18n('GoPay'),
    SHOPEEPAY: _k18n('ShopeePay'),
    OVO: _k18n('OVO'),
    BCA: 'BCA',
    BNI: 'BNI',
    BRI: 'BRI',
    MANDIRI: 'MANDIRI',
    BTPN: 'BTPN',
    CIMB: 'CIMB',
    PERMATA: 'PERMATA',
    COD: _k18n({ text: 'Cash on Delivery', id: 'k_399564' }),
});

export const getFormatLogisticsTime = (time: number) => {
    if (LOCALE === 'pt-BR') {
        return dayjs(time).format('MM/DD/YYYY HH:mm');
    }
    if (CountryNameList.IDN.includes(currentCountry) || LOCALE === 'id') {
        // 印尼用东七区
        return `${dayjs(time).utcOffset(7).format('DD/MM/YYYY HH:mm:ss')} WIB`;
    }
    return dayjs(time).format('YYYY/MM/DD HH:mm');
};

export function $k18n(params) {
    if (!params) return '';
    else return _k18n(params);
}

/**
 * 复制文本到剪切板
 * @params v: 原文本
 */
export async function copyStr(str: string) {
    // 最好是string类型 否则可能会报错
    if (Platform.OS === 'web') {
        const input = document.createElement('input');
        input.value = str;
        document.body.appendChild(input);
        input.select();
        input.setSelectionRange(0, input.value.length);
        document.execCommand('Copy');
        document.body.removeChild(input);
    } else {
        Clipboard.setString(String(str));
    }
}
